<template lang="pug">
  component(v-bind:is='layoutComponent()')
</template>

<script>
import LayoutFull from './LayoutFull'
// import LayoutOnlyMedia from './LayoutOnlyMedia'
// import LayoutOnlyDevices from './LayoutOnlyDevices'
import LayoutOnlyOwnMedia from './LayoutOnlyOwnMedia'

export default {
  props: [],
  components: {
    LayoutFull,
    // LayoutOnlyMedia,
    // LayoutOnlyDevices,
    LayoutOnlyOwnMedia
  },
  created () {
  },
  data () {
    return {
      skin: this.$store.state.User.user.skin
    }
  },
  methods: {
    layoutComponent () {
      if (this.skin === 'onlyOwnMedia') {
        this.$router.push({ path: '/layout-config/' })
        return 'LayoutOnlyOwnMedia'
      }
      this.$router.push({ path: '/layout-full/library/devices/medium,0' })
      return 'LayoutFull'
    }
  },
  computed: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LayoutRouter.vue